import {
	DOCKET_ACCESS_REQUIREMENT_SCOPE,
	DOCKET_ACCESS_REQUIREMENT_TYPE,
	getDocketAccessRequirements,
} from '../../../../common/utils/myDay/driverDaySteps';
import { groupAccessItems } from '../../../utils/groupAccessItems';

const RETURN_ITEM_KIND = {
	[DOCKET_ACCESS_REQUIREMENT_TYPE.KEY]: 'Key / FOB',
	[DOCKET_ACCESS_REQUIREMENT_TYPE.ACCESS_PASS]: 'Access pass',
	[DOCKET_ACCESS_REQUIREMENT_TYPE.EQUIPMENT]: 'PPE / equipment',
};
// Hand-back order: the key, then passes, then PPE (location before POS in each).
const RETURN_ITEM_ORDER = [
	DOCKET_ACCESS_REQUIREMENT_TYPE.KEY,
	DOCKET_ACCESS_REQUIREMENT_TYPE.ACCESS_PASS,
	DOCKET_ACCESS_REQUIREMENT_TYPE.EQUIPMENT,
];
const PASS_FALLBACK_TITLE = {
	[DOCKET_ACCESS_REQUIREMENT_SCOPE.LOCATION]: 'Location access pass',
	[DOCKET_ACCESS_REQUIREMENT_SCOPE.PLACE]: 'POS access pass',
};

/**
 * The keys, access passes and PPE a stop needed, as items to hand back at the
 * end of the day: the start-of-day requirements (getDocketAccessRequirements)
 * without site sign-in, which is nothing to return.
 * Returns [{ id, kind, title }], kind 'Key / FOB' | 'Access pass' | 'PPE / equipment'.
 */
export const getDocketReturnItems = (docket) => {
	const requirements = getDocketAccessRequirements(docket);

	return RETURN_ITEM_ORDER.flatMap(type => requirements
		.filter(requirement => requirement.type === type)
		.map(requirement => ({
			id: `${requirement.scope}:${requirement.type}`,
			kind: RETURN_ITEM_KIND[type],
			type,
			value: requirement.value,
			title: requirement.value || PASS_FALLBACK_TITLE[requirement.scope],
		})));
};

/** Shared items stay at their first stop in route order, with every confirmation id. */
export const getReturnKeyStops = dockets => groupAccessItems((dockets || [])
	.map(docket => ({ docket, items: getDocketReturnItems(docket) })));
